import { render, staticRenderFns } from "./editItemReleaseType.vue?vue&type=template&id=836a2554"
import script from "./editItemReleaseType.vue?vue&type=script&lang=js"
export * from "./editItemReleaseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports